import React from 'react';

const LocationPage = () => (
  <div style={{ width: '100%', height: '100%' }}>
    <iframe
      title="Google Maps Location"
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3476.2902973190844!2d38.79304819365222!3d9.020705417345248!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b8500052ab5eb%3A0x96f0cad7eb520edf!2z4Ymj4YiI4Ymk4Ym1L0JhbGViZXQgUmVhbCBFc3RhdGUgU0Mu!5e0!3m2!1sen!2set!4v1772652039396!5m2!1sen!2set"
      width="100%"
      height="100%"
      style={{ border: 0, width: '100%', height: '100%' }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
);

export default LocationPage;
